<script setup>

// import {Jupiter, getPlatformFeeAccounts, RouteInfo, TOKEN_LIST_URL} from "@jup-ag/core";
import {Connection, PublicKey} from "@solana/web3.js";
import { useWallet } from 'solana-wallets-vue';
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import {watchEffect, reactive,ref} from "vue";
import SwapInner from "./SwapInner.vue";

const connection = new Connection('https://solana-api.projectserum.com/', 'confirmed')
console.log(connection)
// const data = useWallet()
console.log('checking if connected')
const wallet = reactive( useWallet() )
const connected = ref(wallet.connected)


</script>
<script>
export default {
  components: {
    'swap-inner': SwapInner,
  },
  props: ['from','to'],
  name: 'swap-form'
}
</script>
<template>
  <swap-inner :connection="connection" :connected="connected" :from="from" :to="to"></swap-inner>
</template>



<style scoped>

</style>
